"use client";
import React, { useContext, useState, useEffect } from "react";
import OrdersContent from "./OrdersContent";
import { OrdersContext } from "../../context/OrdersContext";

const OngoingOrders = () => {
  const [activeTab, setActiveTab] = useState("ongoing");
  const { ongoingOrders, deliveredOrders, loading, error } = useContext(OrdersContext);

  const tabs = [
    { key: "ongoing", label: "Ongoing" },
    { key: "delivered", label: "Delivered" },
  ];


  const getCurrentOrders = () => {
    return activeTab === "ongoing" ? ongoingOrders : deliveredOrders;
  };

  if (loading) return <p>Loading orders...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <OrdersContent
      title="Orders"
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      orders={getCurrentOrders()}
    />
  );
};

export default OngoingOrders;
